import $ from 'jquery';
import React from 'react';
import Login from '../../../assets/img/guide/Login.PNG';
import guide1 from '../../../assets/img/guide/guide-1.PNG';
import guide2 from '../../../assets/img/guide/guide-2.PNG';
import AddNode from '../../../assets/img/guide/AddNode.PNG';
import DeleteNode from '../../../assets/img/guide/DeleteNode.PNG';
import ImgUpload from '../../../assets/img/guide/ImgUpload.PNG';
import Background from '../../../assets/img/guide/Background.PNG';
import ExportImg from '../../../assets/img/guide/ExportImg.PNG';
import ArrangeNode from '../../../assets/img/guide/ArrangeNode.PNG';
import ShowHideNode from '../../../assets/img/guide/ShowHideNode.PNG';
import SaveBtn from '../../../assets/img/guide/SaveBtn.PNG';

import styled from 'styled-components';
// import '../../../components/familytree/css/style.css';

export const GuideImg = styled.img`
  max-height: 300px;
  max-width: 600px;
  margin: 15px;
`;

const Guide = () => {
  const fadeToggle = (e) => {
    const contentDiv = $(e.target).next();
    // // debug-console.log('fadeToggle: ', contentDiv);
    contentDiv.slideToggle(200);
  };

  return (
    <div id="guide" className="modal-content-wrapper">
      <div className="main-content">
        <div id="main_0_DivCode">
          <div>
            <ol type="I">
              <li>
                <h4>Đăng nhập</h4>
                <div>Để lưu dữ liệu hoặc upload ảnh, bạn cần đăng nhập vào tài khoản của mình.</div>
                <div>
                  Hiện tại để thuận tiện chúng tôi chỉ hỗ trợ duy nhất phương thức đăng nhập bằng
                  tài khoản GMail.
                </div>
                <GuideImg src={Login} />
              </li>

              <li>
                <h4>Các chức năng chính:</h4>
                <ol>
                  <li>
                    <a onClick={fadeToggle}>Tạo cây, thêm và xóa thành viên.</a>
                    <ul style={{ display: 'none' }}>
                      <li>
                        Bạn có thể chọn bắt đầu với cây mặc định (3 đời) hoặc các cây mẫu (4-5-6
                        đời).
                      </li>
                      <GuideImg src={guide1} />
                      <li>Bạn có thể thêm một người mới bằng cách điền tên rồi ấn nút Thêm.</li>
                      <GuideImg src={AddNode} />
                      <li>Để xóa, chọn người cần xóa và bấm nút Xóa.</li>
                      <GuideImg src={DeleteNode} />
                    </ul>
                  </li>

                  <li>
                    <a onClick={fadeToggle}>Lưu thông tin, ảnh đại diện cho mỗi người.</a>
                    <ul style={{ display: 'none' }}>
                      <li>
                        Bạn có thể cập nhật thông tin cơ bản của người đang Chọn bao gồm: tên, tuổi,
                        ảnh, ghi chú...
                      </li>
                      <GuideImg src={guide2} />
                      <li>
                        Để thay đổi ảnh đại diện cho người đang chọn, bấm Upload.
                        <br />
                        Sau đó, bạn upload ảnh mới từ máy của bạn lên, ấn Cập nhật thông tin để hoàn
                        tất Cập nhật.
                        <br />
                        Lưu ý: Dung lượng ảnh tối đa 3 MB, và bạn cần Đăng nhập để có thể Cập nhật
                        thông tin.
                      </li>
                      <GuideImg src={ImgUpload} />
                    </ul>
                  </li>

                  <li>
                    <a onClick={fadeToggle}>Thêm ảnh nền, xuất ảnh dưới dạng PNG.</a>
                    <ul style={{ display: 'none' }}>
                      <li>
                        Bạn có thể Thêm ảnh nền/Bỏ ảnh nền cho cây của mình và sắp xếp lại cho cân
                        đối.
                      </li>
                      <GuideImg src={Background} />
                      <li>Sau đó bạn có thể in toàn bộ ra ảnh dạng PNG để lưu trữ hoặc in ấn.</li>
                      <GuideImg src={ExportImg} />
                    </ul>
                  </li>

                  <li>
                    <a onClick={fadeToggle}>
                      Di chuyển, Tự động sắp xếp, ẩn các thành viên trong cây.
                    </a>
                    <ul style={{ display: 'none' }}>
                      <li>
                        Bạn có thể tùy ý kéo thả để di chuyển vị trí mỗi người trong cây.
                        <br />
                        Để cây tự động sắp xếp lại thẳng hàng cột, ấn nút Sắp xếp.
                      </li>
                      <GuideImg src={ArrangeNode} />
                      <li>
                        Bạn có thể Ẩn/Hiện/Xóa/Bỏ Chọn người đang chọn, hoặc Hiện Tất Cả những người
                        đang ẩn.
                      </li>
                      <GuideImg src={ShowHideNode} />
                    </ul>
                  </li>

                  <li>
                    <a onClick={fadeToggle}>Lưu dữ liệu vào hệ thống</a>
                    <ul style={{ display: 'none' }}>
                      <li>
                        Trước tiên bạn cần đăng nhập vào tài khoản của mình.
                        <br />
                        Sau khi thực hiện các thay đổi, bạn cần ấn nút Lưu dữ liệu để lưu toàn bộ dữ
                        liệu của cây vào hệ thống.
                        <br />
                        Lần sau đăng nhập lại, hệ thống sẽ tự động tải lại dữ liệu được bạn lưu lần
                        cuối.
                      </li>
                      <GuideImg src={SaveBtn} />
                    </ul>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guide;
